import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  VerifiedUser as CertificateIcon,
  Assignment as AssignmentIcon,
  Search as SearchIcon,
  Close as CloseIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Verified as VerifiedIcon,
  Science as ScienceIcon,
  Tune as TuneIcon,
  History as HistoryIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({
  isMobile,
  onClose,
  collapsed = false,
  onCollapseToggle = () => {},
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const MenuItems = [
    {
      title: 'Dashboard',
      icon: DashboardIcon,
      path: '/main/certificate-cell/dashboard',
      id: 'dashboard',
    },
    // {
    //   title: 'Applications',
    //   icon: AssignmentIcon,
    //   path: '/main/certificate-cell/applications',
    //   id: 'applications',
    // },
    // {
    //   title: 'Issue Certificate',
    //   icon: CertificateIcon,
    //   path: '/main/certificate-cell/issue-certificate',
    //   id: 'issue-certificate',
    // },
    // {
    //   title: 'Certificate History',
    //   icon: HistoryIcon,
    //   path: '/main/certificate-cell/certificate-history',
    //   id: 'certificate-history',
    // },
    {
      title: 'Laboratory Search',
      icon: SearchIcon,
      path: '/main/laboratory-search',
      id: 'laboratory-search',
      openNewTab: true,
    },
    {
      title: 'Scope Master Search',
      icon: ScienceIcon,
      path: '/main/view-scope-master',
      id: 'view-scope-master',
      openNewTab: true,
    },
    {
      title: 'Equipment Master Search',
      icon: TuneIcon,
      path: '/main/view-equipment-master',
      id: 'view-equipment-master',
      openNewTab: true,
    },
  ];

  const handleSectionClick = (item) => {
    if (item.openNewTab) {
      window.open(item.path, '_blank');
    } else {
      navigate(item.path);
    }
    if (isMobile) {
      onClose();
    }
  };

  return (
    <>
      <Box sx={{
        p: 2,
        borderBottom: '1px solid #e0e0e0',
        transition: 'all 0.3s ease-in-out',
      }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          transition: 'all 0.3s ease-in-out',
        }}>
          {!collapsed ? (
            <Box sx={{
              opacity: 1,
              transition: 'opacity 0.3s ease-in-out',
              flexGrow: 1,
            }}>
              <Typography variant="h6" sx={{
                fontWeight: 600,
                color: '#00024c',
                transition: 'all 0.3s ease-in-out',
                fontSize: '0.95rem',
              }}>
                Certificate Cell Dashboard
              </Typography>
            </Box>
          ) : null}

          {!isMobile && (
            <IconButton
              onClick={onCollapseToggle}
              sx={{
                color: '#fafafaff',
                backgroundColor: '#1959b9ff',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  backgroundColor: '#1959b934',
                  color: '#ffffffff',
                },
              }}
            >
              {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          )}

          {isMobile && (
            <IconButton onClick={onClose} sx={{ color: '#00024c' }}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Box>

      <Box sx={{
        p: collapsed ? 1 : 2,
        borderBottom: '1px solid #e0e0e0',
        flexGrow: 1,
        overflowY: 'auto',
        transition: 'padding 0.3s ease-in-out',
      }}>
        <List sx={{ p: 0 }}>
          {MenuItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            const listItemContent = (
              <ListItemButton
                onClick={() => handleSectionClick(item)}
                selected={isActive}
                sx={{
                  borderRadius: 1,
                  justifyContent: collapsed ? 'center' : 'flex-start',
                  px: collapsed ? 1 : 2,
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    transform: 'translateX(2px)',
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#e3f2fd',
                    '&:hover': {
                      backgroundColor: '#bbdefb',
                    },
                  },
                  py: 1,
                }}
              >
                <ListItemIcon sx={{
                  minWidth: collapsed ? 'unset' : 35,
                  justifyContent: 'center',
                  transition: 'all 0.3s ease-in-out',
                }}>
                  <item.icon sx={{
                    fontSize: collapsed ? 24 : 18,
                    color: isActive ? '#1976d2' : '#666',
                    transition: 'all 0.3s ease-in-out',
                  }} />
                </ListItemIcon>
                {!collapsed && (
                  <ListItemText
                    primary={item.title}
                    sx={{
                      opacity: 1,
                      transition: 'opacity 0.3s ease-in-out',
                      '& .MuiListItemText-primary': {
                        fontSize: '0.8rem',
                        fontWeight: isActive ? 600 : 500,
                        color: isActive ? '#1976d2' : 'text.primary',
                        transition: 'all 0.3s ease-in-out',
                      },
                    }}
                  />
                )}
              </ListItemButton>
            );

            return (
              <ListItem key={index} disablePadding sx={{ mb: 0.5 }}>
                {collapsed ? (
                  <Tooltip title={item.title} placement="right" arrow>
                    {listItemContent}
                  </Tooltip>
                ) : (
                  listItemContent
                )}
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
};

export default Sidebar;
